export const reorderArray = (order: string[], array: any[], key: string) => {
  return array.sort((a, b) => {
    return order.indexOf(a[key]) - order.indexOf(b[key]);
  });
};
